import React from "react";
import Header from "../components/Header";
import Hero from "../components/Hero";
import About from "../components/About";
import Collective from "../components/Collective";
import Services from "../components/Services";
import Portfolio from "../components/Portfolio";
import TrustedBy from "../components/TrustedBy";
import Process from "../components/Process";
import BookingForm from "../components/BookingForm";
import Contact from "../components/Contact";
import Footer from "../components/Footer";

export default function HomePage() {
  return (
    <div data-testid="home-page" className="bg-[#050505] text-white">
      <Header />
      <TrustedBy />
      <main>
        <Hero />
        <About />
        <Collective />
        <Services />
        <Portfolio />
        <Process />
        <BookingForm />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}
